import _ from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
import React from "react";
import Table from '../../../../../../../../common/components/table-manager/v1.1/table';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../../../redux/library/selector';
import Popup from '../../../../../../../../common/components/popup';
import EmailTemplateListComponent from '../components/email-template-list.component';



export const EmailTemplateListContainer = React.memo(({
  selectedCollection,
  handleSelectedTemplates,
}: any) => {

  const libraryData = useSelector(selectListItems)
  const [localSelectedCollection, setlocalSelectedCollection] = useState<any>(selectedCollection ?selectedCollection : [])
  const [localSelectedTemplates, setLocalSelectedTemplates] = useState<any>([])
  const [isShowTemplatesListPopup, setIsShowTemplatesListPopup] = useState<boolean>(false);
  const skipNextEffect = useRef(false); // flag to prevent double call
  const currentEntityRef = useRef<any>([]);
  const [columnDefs, setColumnDefs] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Template Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
      { field: 'TemplateTypeId', headerName: 'Template Type', cellRenderer: 'libraryRendererComponent', cellRendererParams: { library: libraryData?.result?.TemplateType } },
  
    ]);
  }

  useEffect(() => {
    setLocalSelectedTemplates(_.uniqBy(selectedCollection?.MediaMappings?.Templates, 'MarketingTemplateId'))
  }, [selectedCollection]);

  const handleAdd = () => {
    setIsShowTemplatesListPopup(true)
  }

  const closeModal = () => {
    setIsShowTemplatesListPopup(false);
  }

  const handleSubmitData = (data: any) => {     
        setLocalSelectedTemplates(data);
        handleSelectedTemplates(data)
      closeModal();
  }

  

  const ShowTemplatesList = () => {
    return (
      <Popup onClose={closeModal}>
        <EmailTemplateListComponent
            selectedCollection={localSelectedCollection}
            closeModal={closeModal} 
            handleSubmitData={handleSubmitData}
        />
      </Popup>
    )
  }

  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
          <title>Add Collection</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      callback: () => handleAdd(),
    },    
  ];

  const handleSelect = useCallback((selectedRows) => {
    currentEntityRef.current = selectedRows;
    handleSelectedTemplates(selectedRows)
  }, []);


  useEffect(() => {
    createColumnDefs();
  }, []);

  return (
    <>
      {isShowTemplatesListPopup ? <ShowTemplatesList /> : <></>}
      <Table
        columnData={columnDefs}
        rowData={localSelectedCollection}
        enableFilter={true}
        onSelect={handleSelect}
        checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: [],
          isDisabled: false,
          keyColumn: 'Id',
        }}
        additionButtons={additionButtons}
        headingName="Templates"
      />

    </>
  )
})

export default EmailTemplateListContainer;
